import React from "react";
import GermanDateInput from "@/components/GermanDateInput";

export function ScaleItem({ item, value, onChange, idx }) {
  return (
    <div className="py-3 border-b border-slate-100 last:border-0" data-testid={`q-item-${item.id}`}>
      <div className="text-sm text-slate-800 mb-2">{idx}. {item.label}</div>
      <div className="flex gap-1.5">
        {[1, 2, 3, 4, 5, 6].map((n) => (
          <button key={n} type="button" onClick={() => onChange(n)} data-testid={`q-item-${item.id}-${n}`}
            className={`w-10 h-10 text-sm font-mono border transition-colors ${value === n ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-700 hover:bg-slate-100"}`}>
            {n}
          </button>
        ))}
      </div>
      <div className="flex justify-between w-[270px] text-[9px] text-slate-400 mt-1"><span>trifft voll zu</span><span>gar nicht</span></div>
    </div>
  );
}

export function TextField({ f, value, onChange }) {
  const label = <span>{f.label}{f.required && <span className="text-rose-600"> *</span>}</span>;
  const common = { value: value || "", onChange: (e) => onChange(e.target.value), className: "input-tech mt-1.5", "data-testid": `q-field-${f.id}` };
  return (
    <label className="text-sm text-slate-800 block">
      {label}
      {f.type === "textarea" && <textarea rows={3} {...common} className="input-tech resize-y mt-1.5" />}
      {f.type === "select" && (
        <select {...common}>
          <option value="">Bitte wählen</option>
          {f.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      )}
      {f.type === "date" && <div className="mt-1.5"><GermanDateInput value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`q-field-${f.id}`} /></div>}
      {f.type === "text" && <input type="text" {...common} />}
    </label>
  );
}
